import React, { useState, useEffect } from "react";
import { Button } from "../../../../../_helpers/components/Button";
import { InputForm } from "../../../../../_helpers/components/Forms/InputLabel";
import { useNavigate, useParams } from "react-router-dom";
import { addBadgeuse, editBadgeuse } from "../../../../../_api/Badgeuse";
import { DefaultDropdown } from "../../../../../_helpers/components/Forms/Dropdown";
import { BackButton } from "../../../../../_helpers/components/BackButton";
import toast from "react-hot-toast";
export const AddBadgeuse = () => {
    const navigate = useNavigate();

    const { establishment_id, badgeuse_id } = useParams();
    const [name, setName] = useState("");
    const [type, setType] = useState({ value: "PHYSICAL", label: "Physique" });
    const [remarks, setRemarks] = useState("");
    const [isSaving, setIsSaving] = useState(false);

    const _create = () => {
        const payload = {
            name: name,
            remarks: remarks,
            type: type.value,
        };
        setIsSaving(true);
        const request = badgeuse_id
            ? editBadgeuse(badgeuse_id, payload)
            : addBadgeuse(establishment_id, payload);
        request
            .then(() => {
                toast(badgeuse_id ? "La badgeuse a été modifiée." : "La badgeuse a été ajoutée.");
                navigate("/company/establishments/" + establishment_id);
            })
            .catch((resp) => {
                toast.error(resp?.response?.data?.message ?? resp?.data?.message);
            })
            .finally(() => setIsSaving(false));
    };

    return (

        <div className="min-h-full bg-gray-50">
            {/* Header */}
            <div className="bg-white border-b border-gray-200 shadow-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div className="flex items-center justify-between flex-wrap gap-4">
                        <div className="flex items-center space-x-4">
                            <BackButton
                                title="Retour"
                            />
                            <div>
                                <h1 className="text-3xl font-bold text-gray-900">
                                    {badgeuse_id ? "Modifier" : "Ajouter"} une badgeuse
                                </h1>
                                <p className="mt-2 text-sm text-gray-600">
                                    {/* {category_id ? "Modifiez" : "Créez"} une catégorie socio-professionnelle */}
                                </p>
                            </div>
                        </div>
                        <div className="flex flex-wrap gap-2">
                            <Button
                                action={() => _create()}
                                name={badgeuse_id ? "Modifier" : "Ajouter"}
                                loading={isSaving}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Contenu principal */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                    <InputForm
                        name="Nom"
                        value={name}
                        placeholder="Nom"
                        type="text"
                        set={setName}
                        required={true}
                    />
                    <div className="mt-2 mb-2 ">
                        <DefaultDropdown
                            name="Type de badgeuse"
                            required={true}
                            options={[
                                { value: "PHYSICAL", label: "Physique" },
                                { value: "WEB", label: "Internet" },
                                { value: "MOBILE", label: "Mobile" },
                            ]}
                            value={type}
                            onChange={(e) => setType(e.target.value)}
                        />
                    </div>
                    <InputForm
                        name="Notes"
                        value={remarks}
                        placeholder="Nom"
                        type="textarea"
                        set={setRemarks}
                        required={false}
                    />
                </div>
            </div>
        </div>


    );
};
